import React from 'react';
import { useParams } from 'react-router-dom';
import { UiComponent } from 'components';
import useSchedule from './useSchedule';
import DayTable from './DayTable';
import Preview from './Preview';
import Drawer from './Drawer';
import { formatPeriod } from './utils';
import * as styles from './style';

function Schedule() {
  const { id } = useParams();
  const eventId = Number(id);
  const {
    data,
    dates,
    selectedDate,
    setSelectedDate,
    dayItems,
    draft,
    setDraft,
    previewDate,
    previewItems,
    previewDraftId,
    isSaving,
    isPublishing,
    canMove,
    isGrouped,
    handleMove,
    handleOpenCreate,
    handleOpenEdit,
    handleOpenDuplicate,
    handleCloseDraft,
    handleSubmitDraft,
    handleDelete,
    handleTogglePublished,
  } = useSchedule(eventId);

  return (
    <div css={styles.page}>
      <UiComponent.PageTitle>
        {data?.title ?? '봉사 일정 관리'}
      </UiComponent.PageTitle>

      {data && (
        <>
          <UiComponent.Box>
            <div css={styles.boxHead}>
              <UiComponent.BoxTitle title="일정 공개 설정" />
              <UiComponent.Button
                variant={data.published ? 'border' : 'contained'}
                color={data.published ? 'grey' : 'black'}
                css={{ height: 32, padding: '0 12px' }}
                disabled={isPublishing}
                onClick={handleTogglePublished}
              >
                {data.published ? '비공개로 전환' : '일정 공개'}
              </UiComponent.Button>
            </div>
            <div css={styles.publishRow}>
              <p>
                <span>봉사 기간</span>
                {formatPeriod(dates)}
              </p>
              <p>
                <span>현재 상태</span>
                <em css={styles.stateBadge(data.published)}>
                  {data.published ? '공개' : '비공개'}
                </em>
              </p>
            </div>
          </UiComponent.Box>

          <div css={styles.columns}>
            <div>
              <DayTable
                dates={dates}
                selectedDate={selectedDate}
                onSelectDate={setSelectedDate}
                items={dayItems}
                disabled={isSaving}
                canMove={canMove}
                isGrouped={isGrouped}
                onMove={handleMove}
                onCreate={handleOpenCreate}
                onEdit={handleOpenEdit}
                onDuplicate={handleOpenDuplicate}
                onDelete={handleDelete}
              />
            </div>
            <div>
              <Preview
                dates={dates}
                date={previewDate}
                items={previewItems}
                draftId={previewDraftId}
              />
            </div>
          </div>
        </>
      )}

      {draft && (
        <Drawer
          draft={draft}
          dates={dates}
          isSaving={isSaving}
          onChange={setDraft}
          onClose={handleCloseDraft}
          onSubmit={handleSubmitDraft}
        />
      )}
    </div>
  );
}

export default Schedule;
